import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoomIdService } from './room-id.service';
import { FormGroup } from '@angular/forms';
import { EstimateService } from './estimate.service';
import { UserService } from '../user/user.service';
import { AuthService } from '../user/auth.service';
import { UIMesageService } from '../common/ui-message.service';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ResponsiveService } from '../common/responsive.service';




@Component({
    selector: 'provide-estimate',
    templateUrl: './provide-estimate.component.html',
    styleUrls: ['./provide-estimate.component.scss']
})
export class ProvideEstimateComponent implements OnInit, OnDestroy {
    provideEstimateForm: FormGroup;
    smallScreen: boolean;
    constructor(
        private roomIdService: RoomIdService,
        public estimateService: EstimateService,
        public userService: UserService,
        public authService: AuthService,
        private uiMessage: UIMesageService,
        private logger: LoggerService,
        public responsiveService: ResponsiveService,
    ) {
    }

    ngOnInit() {
        this.provideEstimateForm = new FormGroup({
        });
    }

    public get isOwner(): boolean {
        if (this.roomIdService.getCurrentRoomID() === this.userService.getRoomId()) {
            return true;
        } else {
            return false;
        }
    }

    ngOnDestroy() {
        this.estimateService.unsubscribe();
    }

    getSelectedClass(storyPoints: string): string {
        //     this.logger.error('getSElectedClass', storyPoints, this.estimateService.userStoryPoints);
        if (storyPoints === this.estimateService.userStoryPoints) {
            return 'selected';
        }
        return '';
    }


    async submitEstimate(storyPoints: string) {
        this.logger.log('submitEstimate: ', storyPoints);
        if (!this.userService.isLoggedIn()) {
            const message = 'Internal Error: Submit failed (not logged in).';
            this.uiMessage.warning(message);
            throw (message);
        }
        try {
            await this.estimateService.createEstimate(this.roomIdService.getCurrentRoomID(), this.userService.getDisplayName(), this.userService.getUid(), storyPoints);
            this.uiMessage.success('Estimation has been submitted.');
            //   this.router.navigate([this.roomIdService.getUrlPokerRoom() + '/' + storyPoints]);

        } catch (error) {
            this.uiMessage.error(error, 'Submit failed (createEstimate). ');
        }
    }
}
